import { useContext, useMemo } from 'react'

import { UploadProgressContext } from '../context/UploadProgressContext'

export const useUploadProgress = () => {
  const context = useContext(UploadProgressContext)

  const uploads = useMemo(() => Array.from(context.uploads.values()), [context.uploads, context.version])
  const activeUploads = useMemo(() => uploads.filter((u) => u.status === 'uploading'), [uploads])
  const nonCancelledUploads = useMemo(() => uploads.filter((u) => u.status !== 'cancelled'), [uploads])
  const hasErrors = useMemo(() => nonCancelledUploads.some((u) => u.status === 'error'), [nonCancelledUploads])
  const hasSuccess = useMemo(() => nonCancelledUploads.some((u) => u.status === 'success'), [nonCancelledUploads])
  const allCompleted = useMemo(
    () =>
      nonCancelledUploads.length > 0 &&
      nonCancelledUploads.every((u) => u.status === 'success' || u.status === 'error'),
    [nonCancelledUploads]
  )
  const allSuccess = useMemo(
    () => nonCancelledUploads.length > 0 && nonCancelledUploads.every((u) => u.status === 'success'),
    [nonCancelledUploads]
  )

  return {
    uploads,
    activeUploads,
    hasErrors,
    hasSuccess,
    allCompleted,
    allSuccess,
    registerUpload: context.registerUpload,
    updateUploadProgress: context.updateUploadProgress,
    completeUpload: context.completeUpload,
    failUpload: context.failUpload,
    cancelUpload: context.cancelUpload,
    retryUpload: context.retryUpload,
    removeUpload: context.removeUpload,
    addFiles: context.addFiles,
    getTargetEndpoint: context.getTargetEndpoint,
    getFormDataParams: context.getFormDataParams,
    setFormDataParams: context.setFormDataParams,
    setOnSuccess: context.setOnSuccess,
    clearAllUploads: context.clearAllUploads
  }
}
